export default "__VITE_ASSET__BVO29MeP__"